export const EXPECTED = [
  { label: "", value: "" },
  { label: "Refund/Bayaran Balik", value: "refund" },
  {
    label: "Exchange of Product / Penggantian",
    value: "exchange"
  },
  {
    label: "Expediate delivery / Mempercepatkan Penghantaran",
    value: "expedite_delivery"
  },
  {
    label: "Explanation / Penjelasan",
    value: "explanation"
  },
  {
    label: "Honour Agreement Terms / Menggotakan Perjanjian",
    value: "honour_terms"
  },
  {
    label: "Quantum of Claim / Kuantum ganti rugi Kuantiti ganti rugi",
    value: "quantum_claim"
  },
  {
    label: "Rectification Work(s) / Memperbetulkan / Memperbaiki Kerja",
    value: "rectification_works"
  },
  {
    label: "Reduction in Cost or Price / Mengurangkan Kos atau Harga ",
    value: "price_reduction"
  },
  {
    label: "Repair Item(s) / Memperbaiki Barangan",
    value: "repair_items"
  },
  {
    label: "Terminate Agreement / Menamatkan Perjanjian",
    value: "terminate_agreement"
  },
  {
    label: "Cancellation / Membatalkan urusan",
    value: "cancellation"
  },
  {
    label: "Others / Lain-Lain",
    value: "others"
  }
];
